import 'core-js/stable';
import 'regenerator-runtime/runtime';
//import $ from 'jquery'; //読み込んでもIEでエラー変わらず
import common from './common.js';
//import gbnm_purchase from './gbnm_purchase.js';
import am530 from './am530.js';
